import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles((theme) => ({
  divider: {
    backgroundColor: theme.palette.neutralBackground,
  },
  small: {
    height: '1px',
  },
  large: {
    height: '10px',
  },
}));

export default useStyles;
